export default __webpack_public_path__ + "static/media/t5.min.9e69cbb6.png";